import * as React from 'react'
import {SpecialOfferCompactList, SpecialOfferCompactListInner} from "src/services/api";
import {withTranslation, WithTranslation} from "react-i18next";
import ReactAliceCarousel from "react-alice-carousel";
import "react-alice-carousel/lib/alice-carousel.css";
import {Card, CardHeader, CardImg} from "reactstrap";
import {selectedLang} from "App/helper";
import {CAROUSEL_AUTOPLAY, CAROUSEL_AUTOPLAYINTERVAL_MS, Language} from "App/constants";
import {Ribbon} from "App/fragments/Ribbon";

interface StateToProps {
    items: SpecialOfferCompactList
    className: string
    onChooseAction: (item: SpecialOfferCompactListInner) => void
}

class _CarouselBox extends React.PureComponent<StateToProps & WithTranslation> {

    constructor(props: StateToProps & WithTranslation, context: any) {
        super(props, context);
    }

    render () {
        function itemAsSpecialOfferCompactListInner(item: SpecialOfferCompactListInner | null, key: number|string) {
            return <div className={className} key={key} onDragStart={e => e.preventDefault()} onClick={() => item&&onChooseAction(item)}>
                {item&&<Ribbon className={"reactive ribbon-carouselbox ribbon-small-" + language}/>}
                {
                    item ?
                        <Card className="productListWrap">
                            <CardHeader className={"text-truncate"}>{item.nameml[language] || '-'}</CardHeader>
                            <div className="image-container">
                                <div className="image-data">
                                    <CardImg src={item.imageurl} className="p-2 image-vertical-center"/>
                                </div>
                            </div>
                        </Card> :
                        null
                }
            </div>;
        }

        // Hack: compute actual count of items based on the logic defined in function setTotalItemsInSlide
        // inside node_modules/react-alice-carousel/lib/utils/common.js
        var responsiveConfig: Object = {"0":{items:1},"540":{items:4}};
        var itemsCount = 1;
        if (responsiveConfig) {
            var configWidths: String[] = Object.keys(responsiveConfig);
            if (configWidths.length) {
                configWidths.forEach((width: string) => {
                    if (Number(width) < window.innerWidth) {
                        itemsCount = responsiveConfig[width].items || itemsCount;
                    }
                });
            }
        }

        var {items, className, i18n, onChooseAction} = this.props;
        const language: Language = selectedLang(i18n);
        var staticCarousel: boolean = items.length<=itemsCount;
        var missing = staticCarousel&&items.length%itemsCount?itemsCount-(items.length%itemsCount):0;
        var mappedItems: Object[] = [
            ...items.map(item => itemAsSpecialOfferCompactListInner(item, item.id)),
            ...Array.from(Array(missing).keys()).map(value => {
                return itemAsSpecialOfferCompactListInner(null,  "l" + value)
            })
        ];
        return <ReactAliceCarousel mouseTrackingEnabled={!staticCarousel}
                                   touchTrackingEnabled={!staticCarousel}
                                   items={mappedItems}
                                   controlsStrategy={"responsive"}
                                   responsive={responsiveConfig}
                                   buttonsDisabled={staticCarousel}
                                   autoPlay={!staticCarousel&&CAROUSEL_AUTOPLAY} autoPlayInterval={CAROUSEL_AUTOPLAYINTERVAL_MS}/>;
    }
}

export const CarouselBox = withTranslation('common')(_CarouselBox);


// WEBPACK FOOTER //
// ./src/components/CarouselBox.tsx